import getConfig from "next/config";
import { createFeatureSet, createFeatureConfigs } from "@grandvisionhq/state";
const { publicRuntimeConfig: publicRuntimeConfig$1 } = getConfig();
const endpoints = publicRuntimeConfig$1.grandvision.endpoints ?? {};
const apiUrl = publicRuntimeConfig$1.grandvision.apiUrl ?? "";
const apiConfig = {
  apiUrl,
  cartsUrl: endpoints.carts,
  locationsUrl: endpoints.locations,
  ordersUrl: endpoints.orders,
  paymentsUrl: endpoints.payments,
  productsUrl: endpoints.products,
  storesUrl: endpoints.stores,
  subscriptionsUrl: endpoints.subscriptions
};
const { publicRuntimeConfig } = getConfig();
const featureSet = createFeatureSet(publicRuntimeConfig.grandvision.features ?? []);
const featureConfigs = createFeatureConfigs(publicRuntimeConfig.grandvision.featureConfigs ?? {});
const featureToggles = {
  ...featureSet,
  featureConfigs
};
export {
  apiConfig as a,
  featureToggles as f
};
//# sourceMappingURL=feature-toggles.js.map
